import { Injectable } from '@angular/core';
import { Router, CanActivate, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { User } from '@tripointe/tripointe-cms/data-access';

@Injectable({ providedIn: 'root' })
export class DefaultPageGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(): boolean | UrlTree {
    const defaultPageUrl = this.getDefaultPageUrl();

    return this.router.parseUrl(defaultPageUrl);
  }

  getDefaultPageUrl(): string {
    const user = this.authService.getLoggedUserData();

    if (!user.permissions.length) {
      return '/edit-profile';
    }

    if (user.homepage && this.homePageIsPermitted(user)) {
      return `/${user.homepage.name}`;
    }

    return `/${user.permissions[0].name}`;
  }

  private homePageIsPermitted(user: User): boolean {
    return user.permissions.some(permission => permission.name === user.homepage.name);
  }
}
